import teacherService from 'ApiService/Admin/teacherService';
import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';

const SelectTeacher = ({
  selectedTeacher,
  setSelectedTeacher,
  testData,
  selectedDepartment,
}) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTeachers = useCallback(async () => {
    if (!selectedDepartment) return;
    setLoading(true);
    try {
      const response = await teacherService.getAllTeacher(null, null, selectedDepartment);
      if (response.data.success) {
        setTeachers(response.data.data);
      } else {
        toast.error(response.data.message || 'Failed to fetch teachers.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch teachers.'
      );
    } finally {
      setLoading(false);
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (selectedDepartment && testData?.courseId && testData?.batchId) {
      fetchTeachers();
    }
  }, [selectedDepartment, testData?.courseId, testData?.batchId, fetchTeachers]);

  const handleTeacherSelection = (teacherId) => {
    setSelectedTeacher(teacherId);
  };

  if (
    !testData?.courseId ||
    !testData?.batchStructureId ||
    !testData?.batchId
  ) {
    return (
      <div className="p-4 text-center text-red-500">
        Please complete Step 1 first - select course, batch structure, and
        batch.
      </div>
    );
  }

  return (
    <div className="mt-4 h-full w-full rounded-[20px] p-5 dark:!bg-navy-800 md:mt-5">
      <div className="mb-4 rounded-lg bg-blue-50 p-3 dark:!bg-navy-700">
        <p className="text-sm text-blue-700 dark:text-blue-200">
          <strong>Selected:</strong> Course ID: {testData.courseId} | Batch
          Structure: {testData.batchStructureId} | Batch: {testData.batchId}
        </p>
      </div>

      <div className="mb-4">
        <label className="mb-2 block text-sm font-bold text-gray-700 dark:text-white">
          Select Teacher to Assign
        </label>
        <select
          className="w-full rounded-md border border-gray-300 p-3 dark:border-gray-600 dark:!bg-navy-800 dark:text-white"
          value={selectedTeacher || ''}
          onChange={(e) => handleTeacherSelection(e.target.value)}
        >
          <option value="">Select a Teacher</option>
          {loading ? (
            <option>Loading teachers...</option>
          ) : (
            teachers.map((teacher) => (
              <option key={teacher._id} value={teacher._id}>
                {teacher.name} {teacher.email ? `(${teacher.email})` : ''}
              </option>
            ))
          )}
        </select>
      </div>

      {loading && (
        <div className="flex h-40 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      )}

      {!loading && teachers.length === 0 && (
        <div className="mt-4 text-center text-gray-500">
          No teachers available for assignment.
        </div>
      )}
    </div>
  );
};

export default SelectTeacher;
